import { CookieOptions } from "./cookie.models";
import { CookieManager } from "./cookie_manager";
import { IStorage } from "./storage.interface";

export class CookiesStorageClass implements IStorage {
    //private cookies: CookieManager;
    private _cookiePrefix: string = "";
    private cachedRootDomain: string;

    constructor() {
        
    }
    
    

    public isSupported(): boolean {
        return true;
        // const cookies = JsCookie.getInstance();
        // let result = false;
        // try {
        //     const key = "isSupportedCookieKey";
        //     const value = "isSupportedCookieValue";
        //     cookies.set(key, value, null);
        //     if (cookies.get(key) === value) {
        //         cookies.remove(key, null);
        //         result = true;
        //     }
        // } catch (ex) {
        //     result = false
        // } finally {
        //     return result;
        // }
    }

    public setPrefix(val: string): void{
        this._cookiePrefix = val;
    }

    public get(key: string, options: CookieOptions = {}): any {
        return CookieManager.getCookie(this._cookiePrefix + key);
    }
    getParsed<T>(key: string): T {
        throw new Error("Method not implemented.");
    }

    public set(key: string, value: string | object, options: CookieOptions = {}): boolean {
        if (options && options.daysOfLife) {
            let expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + options.daysOfLife);
            options.expires = expireDate;
        }
        this.setDomain(options);

        return CookieManager.setCookie(this._cookiePrefix + key, value, options);
    }

    public delete(key: string, options = {}): boolean {
        this.setDomain(options);
        CookieManager.deleteCookie(this._cookiePrefix + key, options);
        return true;
    }

    public deleteAllByName(key: string): boolean {
        CookieManager.deleteAllCookiesByName(this._cookiePrefix + key);
        return true;
    }

    public clear(): boolean {
        return false;
    }

    private setDomain(options: CookieOptions) {
        if (options.useRootDomain) {
            options.domain = this.getRootDomain();
        } else {
            options.domain = window.location.hostname;
        }
    }

    private getRootDomain(): string {
        let rootDomain: string = "";
        let hostSegments: string[] = window.location.hostname.split(".");
        let domainSegmentsCount: number = 2;
        // if localhost
        if (hostSegments.length < domainSegmentsCount) {
            return window.location.hostname;
        }

        if (this.cachedRootDomain) {
            return this.cachedRootDomain;
        }

        do {
            rootDomain = "." + hostSegments.slice(-domainSegmentsCount).join(".");
        } while (!this.checkWriteDomainCookie(rootDomain) && domainSegmentsCount++ < hostSegments.length);

        this.cachedRootDomain = rootDomain;

        return rootDomain;
    }

    private checkWriteDomainCookie(domain: string): boolean {
        let cookieKey = "mng_ck_dmn_wrt";
        let result = false;

        const options = {
            domain: domain
        } as CookieOptions;
        const value = "Done!";
        CookieManager.setCookie(cookieKey, value, options);

        result = CookieManager.getCookie(cookieKey) === value;

        CookieManager.deleteCookie(cookieKey, { domain: domain });
        return result;
    }

    public getAllKeys(): any{
        const keys = CookieManager.getAllKeys();
        
        return keys;
    }

    getAllItems(): any[] {
        const items = [];
        try {
            const keys = [...this.getAllKeys()]
            for (let key of keys) {
               items.push({key: key, val: this.get(key)})
            }
            return items;
        } catch (ex) {
            return items;
        } 
    }
}

export const CookiesStorage = new CookiesStorageClass();